<template>
  <div>
    <v-list-tile @click="pdfLabelsCall(artwork)">
      <v-list-tile-title>
        Download Exhibition History
      </v-list-tile-title>
    </v-list-tile>
  </div>
</template>

<script>
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  export default {
    props: ['artwork'],
    data: () => ({
      loading: false,
      outputFieldsParams: [],
      sort: 'full_name',
      title: 'Exhibition History',
      subtitle: 'Artwork Title',
    }),
    methods: {
      pdfLabelsCall () {
        this.loading = true;
        setTimeout(function () {
          setTimeout(function () {
            this.pdfLabels()
            this.loading = false
          }.bind(this),0)
        }.bind(this),500)
      },
      pdfLabels () {
        const reportDate = () => new Date()
        const createDocumentDefinition = (reportDate, subHeading, ...contentParts) => {
          const baseDocDefinition = {
            pageSize: 'A4',
            pageMargins: [ 22, 55, 0, 0 ],
            info: {
              title: 'Exhibition History A4',
              subject: 'Exhibition History A4'
            },
            styles: {
              title: { fontSize: 9, bold: true, margin: [8,2,0,0], width: 150 },
              title2: { fontSize: 9, bold: true, margin: [8,2,0,25], width: 150 },
              artwork_title: { fontSize: 12, margin: [8,2,0,0], width: 250 },
            },
            content: [ { columns: [] } ]
          }
          const docDefinition = JSON.parse(JSON.stringify(baseDocDefinition))
          // docDefinition.footer = baseDocDefinition.footer
          docDefinition.content.push(...contentParts)
          return docDefinition
        }

        var stack = {
          stack: [],
        };
        var title_and_year = `${this.artwork['title']}, ${this.artwork['production_date_new']}`
        var exhibitions = this.artwork.exhibitions

        function start_date (e) {
          var out = e.duration_start_year
          var options = { day: 'numeric', month: 'long', year: 'numeric'};
          if (e.duration_start_month) {
            out = out + '-' + e.duration_start_month.toString().padStart(2, "0")
          }
          if (e.duration_start_day) {
            out = out + '-' + e.duration_start_day.toString().padStart(2, "0")
          }
          out = new Date(out).toLocaleDateString("en-US", options)

          return out
        }
        function end_date (e) {
          var out = e.duration_end_year
          var options = { day: 'numeric', month: 'long', year: 'numeric'};

          if (e.duration_end_month) {
            out = out + '-' + e.duration_end_month.toString().padStart(2, "0")
            // out = e.duration_end_month.toLocaleDateString("en-US", options)
          }
          if (e.duration_end_day) {
            out = out + '-' + e.duration_end_day.toString().padStart(2, "0")
          }
          out = new Date(out).toLocaleDateString("en-US", options)
          return out
        }
        function full_date (e) {
          var out = start_date(e)
          if (end_date(e)) {
            out = out + ' - ' + end_date(e)
          }
          return out
        }
        var store_e = () => {
          // console.log('store_e')
          return this.$store.state.exhibitions
        }
        var exhibitions = () => {
          return store_e().filter(t => {
          // console.log(t)
            return t.artworks.map(a => a = a.artwork_id).includes(this.artwork.id)
          })
        }
          // console.log(exhibitions())
        // stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'artwork_title'});
        // stack.stack.push({text: 'PRIVATE ART COLLECTION', style: 'artwork_title'});
        stack.stack.push({text: this.artwork['accession_number'], style: 'title'});
        stack.stack.push({text: this.artwork['full_name'], style: 'title'});
        stack.stack.push({text: this.artwork['title'], style: 'artwork_title'});
        stack.stack.push({text: 'Production Date:' + this.artwork['production_date_new'], style: 'title'});
        stack.stack.push({text: 'Exhibitions:', style: 'artwork_title'});
        for (var e in exhibitions()) {
        // console.log(exhibitions()[e])
          // stack.stack.push({text: 'e.title', style: 'title'});
          stack.stack.push({text: exhibitions()[e].title, style: 'title'});
          stack.stack.push({text: (exhibitions()[e].show_type == 0 ? "Solo show" : "Group show"), style: 'title'});
          stack.stack.push({text: (`${exhibitions()[e].institution} ${exhibitions()[e].city} ${exhibitions()[e].country}`), style: 'title'});
          stack.stack.push({text: (full_date(exhibitions()[e])), style: 'title'});
          stack.stack.push({text: exhibitions()[e].admin_note, style: 'title'});
        }

        // var rowData2 = function rowData2 (a,c) {
        //   var stack = {
        //     stack: [],
        //   };
          // var title_and_year = `${a['title']}, ${a['production_date_new']}`

          var docDefinition = createDocumentDefinition(reportDate(), 'Summary', stack)
          pdfMake.createPdf(docDefinition).download('A4-Exhibition-History.pdf');
        // }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/artworks/PdfEh.vue